import React, { FunctionComponent } from 'react';
import { DeepMap, FieldError } from 'react-hook-form';

import { QuestionProps } from 'scenes/common/components/Questions/types';
import InputFormatQuestion from 'scenes/common/components/Questions/InputFormatQuestion';
import { DateOfBirthQuestionValidators } from './helper';

const DateOfBirthQuestion: FunctionComponent<
  QuestionProps<string> & {
    errors: DeepMap<Record<string, unknown>, FieldError>;
    minAge: number;
    maxAge: number;
    entityType: string;
  }
> = ({
  errors,
  control,
  minAge,
  maxAge,
  question,
  stateKey,
  entityType,
  defaultValue,
  disableRangeValidator,
  changeHandler,
}) => {
  let validate: {};
  const errorMessage = 'Please enter a valid date (DD/MM/YYYY)';
  if (!disableRangeValidator) {
    validate = {
      format: (value: string) =>
        DateOfBirthQuestionValidators.format(value, errorMessage),
      range: (value: string) =>
        DateOfBirthQuestionValidators.range(
          value,
          minAge,
          maxAge,
          `The ${entityType} should be between the age ${minAge} and ${maxAge} (DD/MM/YYYY)`
        ),
    };
  } else {
    validate = {
      format: (value: string) =>
        DateOfBirthQuestionValidators.format(value, errorMessage),
    };
  }
  return (
    <InputFormatQuestion
      size={4}
      errors={errors}
      autoCompleteName="bday"
      format="## / ## / ####"
      placeholder="DD / MM / YYYY"
      mask={['D', 'D', 'M', 'M', 'Y', 'Y', 'Y', 'Y']}
      control={control}
      stateKey={stateKey}
      question={question}
      defaultValue={defaultValue}
      ariaRequired
      changeHandler={changeHandler}
      validationRules={{
        required: true,
        validate,
      }}
    />
  );
};

export default DateOfBirthQuestion;
